<template>
  <div class="hw-tool-wrap">
    <div
      v-for="tool in tools"
      :key="tool.key"
      class="hw-tool"
      :class="`hw-tool--${tool.key}`"
      @click="onTool(tool.key)"
    >
      <img class="hw-tool-icon" :src="tool.icon" alt="">
    </div>
  </div>
</template>

<script setup>
import { nextTick, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import toolRecharge from '@/assets/imgs/act/ann2026/hero/tool-recharge.png'
import toolService from '@/assets/imgs/act/ann2026/hero/tool-service.png'
import toolBack from '@/assets/imgs/act/ann2026/hero/tool-back.png'
import { aihelpLangOptions } from '@/config/lang'
import { loadScript } from '@/utils'
import { loadingService } from '@/utils/loadingService'

const router = useRouter()
const { locale } = useI18n()

const tools = [
  { key: 'recharge', icon: toolRecharge },
  { key: 'service', icon: toolService },
  { key: 'backTop', icon: toolBack },
]

const handleCustom = async () => {
  const aihelpLang = aihelpLangOptions.find((item) => item.appLang === locale.value)?.aihelpLang || 'en'
  if (!window.AIHelpSupport) {
    await loadScript('https://cdn.aihelp.net/webchatv5/aihelp.js')
  }
  const initConfig = {
    domain: 'miniwantechnologycolimited.aihelp.net',
    appId: 'miniwantechnologycolimited_platform_36bbfccee53e93eeaa51b18afe074c83',
    language: aihelpLang,
  }
  const unwatch = watch(locale, () => {
    if (window.AIHelpSupport) {
      const language = aihelpLangOptions.find((item) => item.appLang === locale.value)?.aihelpLang || 'en'
      window.AIHelpSupport.updateSDKLanguage(language)
    }
  })
  nextTick(() => {
    loadingService.show()
    window.AIHelpSupport.initialize(initConfig)
    window.AIHelpSupport.registerAsyncEventListener('initialization', (jsonData) => {
      if (jsonData.isSuccess) {
        window.AIHelpSupport.show('E002')
        loadingService.hide()
      }
    })
    window.AIHelpSupport.registerAsyncEventListener('sessionClose', () => {
      unwatch()
    })
  })
}

const onTool = (key) => {
  if (key === 'backTop') {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    return
  }
  if (key === 'recharge') {
    const resolved = router.resolve({ name: 'Payment' })
    window.open(resolved.href, '_blank')
    return
  }
  if (key === 'service') {
    handleCustom()
  }
}
</script>

<style lang="less" scoped>
.hw-tool-wrap {
  position: fixed;
  right: 20px;
  bottom: 100px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.hw-tool {
  width: 44.6px;
  height: 44.6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  // &:nth-child(1),
  // &:nth-child(2) {
  //   &::before {
  //     content: '';
  //     display: block;
  //     position: absolute;
  //     left: 50%;
  //     bottom: -15px;
  //     transform: translateX(-50%);
  //     width: 6px;
  //     height: 6px;
  //     background-image: url('~@/assets/imgs/act/ann2026/hero/tool-dot.png');
  //     background-size: 100% 100%;
  //     background-repeat: no-repeat;
  //   }
  // }

  &--recharge .hw-tool-icon {
    width: 70px;
  }

  &--service {
    background-image: url('~@/assets/imgs/act/ann2026/hero/tool-circle-2.png');
  }

  &--backTop {
    background-image: url('~@/assets/imgs/act/ann2026/hero/tool-circle-3.png');
  }
}

.hw-tool-icon {
  width: 30px;
  object-fit: contain;
}
</style>
